import { Actions } from '@components/shared/Actions'
import { EditIcon } from '@assets/svgs/EditIcon'
import { InfoIcon } from '@assets/svgs/InfoIcon'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { DetailedSummaryResponseProps } from '../context/types'
import { Tooltip } from '@components/shared/Tooltip'

interface ParseDetailedSummaryProps {
  actionsDisabled: boolean
  data: DetailedSummaryResponseProps[]
  onEdit: (data: DetailedSummaryResponseProps) => void
}

export const parseDetailedSummaryGrid = ({ data, actionsDisabled, onEdit }: ParseDetailedSummaryProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'netTotalAmount',
      columnName: 'Faturamento Líquido',
      align: 'center',
      currency: true,
      value: item.netTotalAmount || 0
    },
    {
      id: 'minimumBilling',
      columnName: 'Faturamento Mínimo',
      align: 'center',
      currency: true,
      value: item.minimumBilling || 0
    },
    {
      id: 'provisions',
      columnName: 'Provisões (+)',
      align: 'center',
      currency: true,
      value: item.provisions || 0
    },
    {
      id: 'reversals',
      columnName: 'Reversões (-)',
      align: 'center',
      currency: true,
      value: item.reversals || 0
    },
    {
      id: 'adjustments',
      columnName: 'Reajustes',
      align: 'center',
      currency: true,
      value: item.adjustments || 0
    },
    {
      id: 'othersNetAmount',
      columnName: (
        <Tooltip title="Soma de Outros Serviços do CL somada à soma de Outros Serviços dos Clientes." placement="top">
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', cursor: 'default' }}>
            Outros Serviços
            <InfoIcon />
          </span>
        </Tooltip>
      ),
      align: 'center',
      currency: true,
      value: item.othersNetAmount || 0
    },
    {
      id: 'taxesPercent',
      columnName: 'Impostos (%)',
      align: 'center',
      value: item.taxPercentage ? `${item.taxPercentage.toFixed(2).replace('.', ',')}%` : '-'
    },
    {
      id: 'action',
      columnName: 'Ações',
      align: 'center',
      minWidth: '5rem',
      maxWidth: '5rem',
      stickyPosition: 'right',
      withoutTooltip: true,
      value: (
        <Tooltip title={actionsDisabled ? 'Não é possível editar o resumo detalhado!' : ''} placement="top-end">
          <Actions
            actions={[{ label: 'Editar', icon: <EditIcon />, onClick: () => onEdit(item) }]}
            disabled={actionsDisabled}
          />
        </Tooltip>
      )
    }
  ])

  return parsedData
}
